define(["exports", "./default", "styled-components"], function (_exports, _default, _styledComponents) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.visuallyHidden = _exports.spread = _exports.size = _exports.resetList = _exports.resetButton = _exports.focusBoxShadow = _exports.device = void 0;
  var device = Object.keys(_default.breakpoints).reduce(function (acc, label) {
    acc[label] = function () {
      return (0, _styledComponents.css)(["@media (min-width:", "){", "}"], _default.breakpoints[label], _styledComponents.css.apply(void 0, arguments));
    };

    return acc;
  }, {});
  _exports.device = device;

  var resetButton = function resetButton() {
    return (0, _styledComponents.css)(["appearance:none;background:0;border:0;cursor:pointer;line-height:24px;margin:0;padding:0;"]);
  };

  _exports.resetButton = resetButton;

  var resetList = function resetList() {
    return (0, _styledComponents.css)(["list-style:none;margin:0;padding:0;"]);
  };

  _exports.resetList = resetList;

  var size = function size(val) {
    return (0, _styledComponents.css)(["width:", "px;height:", "px;"], val, val);
  };

  _exports.size = size;

  var visuallyHidden = function visuallyHidden() {
    return (0, _styledComponents.css)(["clip:rect(1px,1px,1px,1px);height:1px;margin:0;overflow:hidden;padding:0;position:absolute !important;width:1px;"]);
  };

  _exports.visuallyHidden = visuallyHidden;

  var focusBoxShadow = function focusBoxShadow() {
    return (0, _styledComponents.css)(["border-color:", ";box-shadow:0 0 3px 1px ", ";outline:0;"], function (_ref) {
      var theme = _ref.theme;
      return theme.colors.blue;
    }, function (_ref2) {
      var theme = _ref2.theme;
      return theme.colors.blue;
    });
  };

  _exports.focusBoxShadow = focusBoxShadow;

  var spread = function spread() {
    return (0, _styledComponents.css)(["position:fixed;top:0;bottom:0;left:0;right:0;height:100%;width:100%;"]);
  };

  _exports.spread = spread;
});